import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) =>
  createStyles({
    page_wrapper: {},
    page_content: {
      paddingLeft: 125,
      paddingRight: 125,
      paddingBottom: 45,
      paddingTop: 45,
      width: '100%',
      [theme.breakpoints.down('lg1')]: {
        paddingLeft: 80,
        paddingRight: 80,
      },
    },
    rightBlock: {
      width: '100%',
    },
    wrapperTable: {},
    flexWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
    },
    labelText: {
      fontSize: 14,
      color: 'black',
      lineHeight: 'normal',
      margin: 0,
    },
    wrapperFlex: {
      display: 'flex',
      gap: 77,
      marginTop: 45,
      [theme.breakpoints.down('lg1')]: {
        flexDirection: 'column-reverse',
      },
    },
    form_footer_box: {
      width: 125,
      textAlign: 'center',
      '&:not(:first-of-type)': {
        marginLeft: '0 !important',
      },
      '& > a': {
        display: 'flex',
        textDecoration: 'none',
      },
      '& .MuiButtonBase-root': {
        border: '1px solid #1A0063',
        color: '#1A0063',
        transition: '0.3s',
        '&.Mui-disabled': {
          borderColor: '#C4C4C4',
          color: '#C4C4C4',
        },
        '&:hover': {
          backgroundColor: '#1A0063',
          color: '#fff',
        },
      },
    },
    wrapperArea: {
      marginTop: 45,
    },
    wrapperSelectBtn: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 25,
    },
    addProducts: {
      width: 168,
      marginLeft: 'auto',
      position: 'relative',
      textAlign: 'center',
      '&:not(:first-of-type)': {
        // marginLeft: '0 !important',
      },
      '& > a': {
        display: 'flex',
        textDecoration: 'none',
      },
      '& .MuiButtonBase-root': {
        height: 40,
        minHeight: 40,
        fontSize: 16,
        border: '1px solid #1A0063',
        color: '#1A0063',
        transition: '0.3s',
        '&.Mui-disabled': {
          borderColor: '#C4C4C4',
          color: '#C4C4C4',
        },
        '&:hover': {
          backgroundColor: '#1A0063',
          color: '#fff',
        },
      },
    },
    wrapperBottom: {
      background: '#F2F2F2',
      borderRadius: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: 20,
      margin: '25px 0 35px',
      padding: '25px 15px 25px',
    },
    form_btn: {
      width: '100%',
      flexGrow: 1,
      fontWeight: 'bold',
    },
    header_title: {
      textAlign: 'left',
      fontWeight: 800,
      fontSize: '1.625rem',
      lineHeight: 1.26,
      color: '#000',
      width: '50%',
      maxWidth: 658,
      [theme.breakpoints.down('lg1')]: {
        width: '100%',
      },
    },
    descriptionText: {
      fontSize: 14,
      marginTop: 35,
    },
    description: {
      width: '50%',
      maxWidth: 658,
      marginTop: 10,
      [theme.breakpoints.down('lg1')]: {
        width: '100%',
      },
    },
    leftBlock: {
      maxWidth: '100%',
    },
    textArea: {
      maxWidth: '100%',
    },
    closeBtn: {
      width: 45,
      height: 45,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      position: 'absolute',
      top: 25,
      right: 25,
      border: '1px solid #1A0063',
      borderRadius: 100,
      transition: ' 0.3s',
      '&:hover': {
        backgroundColor: '#1A0063',
        '& svg, path': {
          fill: 'white',
        },
      },
      '& svg, path': {
        width: 20,
        height: 20,
        fill: '#1A0063',
      },
    },
    selectedCount: {
      fontSize: 14,
      fontWeight: 800,
      color: '#333',
      paddingTop: 30,
      position: 'absolute',
      textAlign: 'center',
      width: '100%',
    },
    modal: {
      '& .MuiBackdrop-root': {
        background: ' rgba(0, 0, 0, 0.35)',
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: 25,
      padding: '30px 15px',
      '& > *': {
        padding: '0 15px !important',
      },
      minWidth: 400,
      maxWidth: 400,
      minHeight: 400,
      maxHeight: 'calc(100vh - 40vh)',
      height: '100%',
      background: '#fff',
      top: '20vh',
      left: 'calc(50% - 200px)',
      position: 'absolute',
      borderRadius: 5,
      boxShadow: ' 0px 0px 8px 0px rgba(0, 0, 0, 0.15)',
    },
    wrapper_header: {
      '& span': {
        display: 'inline-block',
        fontWeight: 700,
        fontSize: 18,
        marginRight: 5,
      },
      display: 'flex',
      alignItems: 'flex-start',
      gap: 10,
      padding: '0 35px 0 0px',
      fontWeight: 400,
      fontSize: 14,
    },
    close_button: {
      position: 'absolute !important',
      right: 20,
      zIndex: 10,
      top: 30,
      width: 20,
      height: 20,
      padding: 0,
      '& svg, path': {
        width: '50%',
        height: '50%',
      },
    },
    wrapper_body: {
      fontSize: 16,
      fontWeight: 400,
      height: 'calc(100% - 60px - 50px - 25px)',
      overflowY: 'auto',
      paddingRight: '0px !important',
      '& > * ': {
        paddingRight: '15px',
      },
    },
    modal_title: {
      display: '-webkit-box',
      '-webkit-line-clamp': 10,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
      fontWeight: 800,
      marginBottom: 5,
    },
    wrapper_footer: {
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: 11,
      fontWeight: 700,
      '& button': {
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        width: 84,
        height: 30,
        minHeight: 30,
        border: '1px solid #1A123F80',
        fontSize: 10,
        fontWeight: 700,
        textTransform: 'unset',
        padding: 0,
        color: '#000000',
        svg: {
          transition: '0.3s',
        },
        '&:hover svg': {
          filter: ` brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)`,
        },
      },
    },
  })
)
export default useStyles
